var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6805_1113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6272 1.37297C16.7966 -0.457651 13.8287 -0.457651 11.998 1.37293L8.08032 5.29067C6.18676 7.1843 6.36208 10.2015 8.08032 11.9198C8.36805 12.2075 8.68641 12.4422 9.02258 12.6348L9.73762 11.9198C10.2066 11.4507 10.0415 10.9024 10.0331 10.5068C9.93016 10.4338 9.83004 10.3549 9.73762 10.2625C8.85586 9.38083 8.81621 7.86934 9.73762 6.94793C9.87446 6.8111 13.5722 3.11332 13.6553 3.03028C14.5693 2.11625 16.0558 2.11625 16.9698 3.03028C17.8839 3.9443 17.8839 5.43082 16.9698 6.34485L14.3803 8.93442C14.4552 9.34875 14.9046 10.3302 14.6734 11.9493C14.6847 11.9382 14.6982 11.9311 14.7094 11.9198L18.6272 8.00211C20.4577 6.17149 20.4577 3.2036 18.6272 1.37297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2233 7.77656C11.9356 7.48883 11.6172 7.25422 11.2812 7.06152L10.5661 7.77656C10.0971 8.24555 10.2621 8.79387 10.2706 9.18953C10.3736 9.2625 10.4737 9.34137 10.5661 9.43379C11.4479 10.3155 11.4875 11.827 10.5661 12.7484C10.429 12.8855 6.4249 16.8896 6.34479 16.9697C5.43076 17.8837 3.94424 17.8837 3.03021 16.9697C2.11619 16.0557 2.11619 14.5691 3.03021 13.6551L5.92346 10.7619C5.84857 10.3475 5.39912 9.36606 5.63033 7.74699C5.61904 7.75809 5.60545 7.76531 5.5942 7.77652L1.37291 11.9979C-0.457637 13.8285 -0.457637 16.7964 1.37291 18.627C3.20354 20.4576 6.17139 20.4576 8.00201 18.627L12.2233 14.4057C14.0818 12.5473 13.9802 9.5334 12.2233 7.77656Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6805_1113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkPreview);
export default __webpack_public_path__ + "static/media/link-preview.97dfb31348c8c46ac73589fe8da3720a.svg";
export { ForwardRef as ReactComponent };